"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EdgeClient = void 0;
const query_1 = require("../query");
class EdgeClient {
    constructor(params) {
        this.cookieJar = {};
        this.apiKey = params.apiKey;
        const baseUrlList = [...new Set([params.baseUrl, ...(params.failbackUrls ?? [])])];
        let currentUrl = 0;
        this.baseUrls = {
            get length() {
                return baseUrlList.length;
            },
            reset() {
                currentUrl = 0;
                return baseUrlList[currentUrl];
            },
            next: () => {
                currentUrl = (currentUrl + 1) % baseUrlList.length;
                return { value: baseUrlList[currentUrl], done: false };
            },
        };
        this._baseUrl = baseUrlList[0];
        this._baseUrlLastSet = Date.now();
    }
    async health(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/health`,
            optionsOverrides,
        });
        return result.body;
    }
    async listStatuses(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/status`,
            optionsOverrides,
        });
        return result.body;
    }
    async createApiToken(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/api-token/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async listApiTokens(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/api-token/`,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteApiToken(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/api-token/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async setApiTokenEnsureOperatorToken(optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/api-token/ensure-operator-token`,
            optionsOverrides,
        });
        return result.body;
    }
    async getIpMapping(region, privateIp, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ip-mapping/${region}/${privateIp}`,
            optionsOverrides,
        });
        return result.body;
    }
    async updateIpMapping(region, privateIp, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/ip-mapping/${region}/${privateIp}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async listIpMappings(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ip-mapping/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async createIpMapping(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/ip-mapping/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteIpMapping(region, privateIp, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/ip-mapping/${region}/${privateIp}`,
            optionsOverrides,
        });
        return result.body;
    }
    async createEcho(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/echo`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async listOverlays(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/overlay/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async createOverlay(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/overlay/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getOverlay(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/overlay/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteOverlay(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/overlay/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listAdServers(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/adServer/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getAdServer(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/adServer/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async createAdServer(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/adServer/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async updateAdServer(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/adServer/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteAdServer(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/adServer/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async createAdPod(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/ad-pod/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getAdPod(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ad-pod/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listAdPods(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ad-pod/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async updateAdPod(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/ad-pod/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteAdPod(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/ad-pod/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async createAdCreative(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/ad-creative/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getAdCreative(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ad-creative/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listAdCreatives(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ad-creative/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async updateAdCreative(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/ad-creative/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteAdCreative(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/ad-creative/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async setAdCreativeEvent(id, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/ad-creative/${id}/event`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getAdBreak(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ad-break/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listAdBreaks(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ad-break/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async createAdBreak(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/ad-break/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteAdBreak(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/ad-break/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async getAdStorage(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ad-storage`,
            optionsOverrides,
        });
        return result.body;
    }
    async createScte104Injection(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/scte104-injection`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getTls(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/tls`,
            optionsOverrides,
        });
        return result.body;
    }
    async setTls(body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/tls`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async syncTls(optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/tls/sync`,
            optionsOverrides,
        });
        return result.body;
    }
    async getGlobalsettings(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/globalsettings`,
            optionsOverrides,
        });
        return result.body;
    }
    async setGlobalsettings(body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/globalsettings`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteGlobalsettings(optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/globalsettings`,
            optionsOverrides,
        });
        return result.body;
    }
    async testBackupExternalS3s(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/backup/externalS3/test`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async createBackup(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/backup`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getRegion(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/region/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listRegions(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/region/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async createRegion(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/region/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async setRegionDefaultRegion(body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/region/default-region`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteRegion(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/region/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async getImage(name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/image/${name}`,
            optionsOverrides,
        });
        return result.body;
    }
    async createImage(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/image/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteImage(name, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/image/${name}`,
            optionsOverrides,
        });
        return result.body;
    }
    async getMedia(id, optionsOverrides = { json: false }) {
        const result = await this._get({
            resource: `/api/media/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listApplianceInternalStatuses(secret, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/internal-statuses`,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async listApplianceSummaries(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/summary`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listAppliances(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listApplianceRegisteredTypes(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/registered-types`,
            optionsOverrides,
        });
        return result.body;
    }
    async clearApplianceConfig(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/config/clear`,
            optionsOverrides,
        });
        return result.body;
    }
    async listApplianceNdiSources(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/ndi-sources`,
            optionsOverrides,
        });
        return result.body;
    }
    async getAppliance(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async upgradeAppliance(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/upgrade`,
            optionsOverrides,
        });
        return result.body;
    }
    async recreateApplianceTunnels(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/tunnels/recreate`,
            optionsOverrides,
        });
        return result.body;
    }
    async restartAppliance(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/restart`,
            optionsOverrides,
        });
        return result.body;
    }
    async upgradeImageAppliance(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/upgrade-image`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async commandAppliance(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/command`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async listApplianceCommands(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/command`,
            optionsOverrides,
        });
        return result.body;
    }
    async getAppliancePorts(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/ports`,
            optionsOverrides,
        });
        return result.body;
    }
    async setAppliancePorts(id, body, optionsOverrides = {}) {
        const result = await this._patch({
            resource: `/api/appliance/${id}/ports`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async updateAppliance(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteAppliance(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/appliance/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async proxyApplianceGet(id, path, optionsOverrides = { json: false }) {
        const result = await this._get({
            resource: `/api/appliance/${id}/proxy${path}`,
            optionsOverrides,
        });
        return result.body;
    }
    async proxyAppliancePost(id, path, body, optionsOverrides = { json: false }) {
        const result = await this._post({
            resource: `/api/appliance/${id}/proxy${path}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async proxyAppliancePut(id, path, body, optionsOverrides = { json: false }) {
        const result = await this._put({
            resource: `/api/appliance/${id}/proxy${path}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async proxyApplianceDelete(id, path, optionsOverrides = { json: false }) {
        const result = await this._delete({
            resource: `/api/appliance/${id}/proxy${path}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listApplianceInputs(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/inputs`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listApplianceOutputs(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/outputs`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listAppliancePcaps(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/pcap/`,
            optionsOverrides,
        });
        return result.body;
    }
    async getAppliancePcap(applianceId, pcapId, optionsOverrides = { json: false }) {
        const result = await this._get({
            resource: `/api/appliance/${applianceId}/pcap/${pcapId}`,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteAppliancePcap(applianceId, pcapId, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/appliance/${applianceId}/pcap/${pcapId}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listGeoAppliances(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/geoAppliance/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listTunnels(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/tunnel/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listTunnelOutputs(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/tunnel/${id}/outputs`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async createApplianceAllocation(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance-allocation`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getSanity(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/sanity`,
            optionsOverrides,
        });
        return result.body;
    }
    async getTestSleep(s, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/test/sleep/${s}`,
            optionsOverrides,
        });
        return result.body;
    }
    async setStatefulsetScale(name, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/k8s/statefulset/${name}/scale`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getStatefulsetScale(name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/statefulset/${name}/scale`,
            optionsOverrides,
        });
        return result.body;
    }
    async setStatefulsetTag(name, container, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/k8s/statefulset/${name}/${container}/tag`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getStatefulsetTag(name, container, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/statefulset/${name}/${container}/tag`,
            optionsOverrides,
        });
        return result.body;
    }
    async setDeploymentTag(name, container, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/k8s/deployment/${name}/${container}/tag`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getDeploymentScale(name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/deployment/${name}/scale`,
            optionsOverrides,
        });
        return result.body;
    }
    async setDeploymentScale(name, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/k8s/deployment/${name}/scale`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getDeployment(name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/deployment/${name}`,
            optionsOverrides,
        });
        return result.body;
    }
    async getPodStatus(name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/pod/${name}/status`,
            optionsOverrides,
        });
        return result.body;
    }
    async getPodLogs(name, containerName, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/pod/${name}/logs/${containerName}`,
            optionsOverrides,
        });
        return result.body;
    }
    async deletePod(name, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/k8s/pod/${name}`,
            optionsOverrides,
        });
        return result.body;
    }
    async getPod(name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/pod/${name}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listPods(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/pod/`,
            optionsOverrides,
        });
        return result.body;
    }
    async listKubernetesNodes(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/node/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listIngresses(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/ingress/`,
            optionsOverrides,
        });
        return result.body;
    }
    async listResourceUsages(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/resourceUsage/`,
            optionsOverrides,
        });
        return result.body;
    }
    async getKubernetesNode(regionId, name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/region/${regionId}/node/${name}`,
            optionsOverrides,
        });
        return result.body;
    }
    async updateKubernetesNode(regionId, name, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/k8s/region/${regionId}/node/${name}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async listRegionKubernetesNodes(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/region/${id}/node/`,
            optionsOverrides,
        });
        return result.body;
    }
    async getRegionVideoScale(regionId, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/region/${regionId}/videoscale/`,
            optionsOverrides,
        });
        return result.body;
    }
    async setRegionVideoScale(regionId, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/k8s/region/${regionId}/videoscale/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getRegionThumbScale(regionId, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/region/${regionId}/thumbscale/`,
            optionsOverrides,
        });
        return result.body;
    }
    async setRegionThumbScale(regionId, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/k8s/region/${regionId}/thumbscale/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async listAlarms(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/alarm/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async setAlarm(alarmId, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/alarm/${alarmId}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async backupMonitorAlarms(body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/alarm/backup-monitor/`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async getPort(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/port/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listPorts(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/port/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async login(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/login/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async listLoginMethods(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/login-methods`,
            optionsOverrides,
        });
        return result.body;
    }
    async getSsoMetadataSaml(regularQueryParams, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/sso-metadata/saml`,
            regularQueryParams,
            optionsOverrides,
        });
        return result.body;
    }
    async getSsoMetadataOidc(regularQueryParams, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/sso-metadata/oidc`,
            regularQueryParams,
            optionsOverrides,
        });
        return result.body;
    }
    async impersonate(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/impersonate/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async unimpersonate(optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/unimpersonate`,
            optionsOverrides,
        });
        return result.body;
    }
    async getCurrentUser(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/current-user`,
            optionsOverrides,
        });
        return result.body;
    }
    async totpCurrentUsers(optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/current-user/totp`,
            optionsOverrides,
        });
        return result.body;
    }
    async setCurrentUserTotpVerify(body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/current-user/totp/verify`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteCurrentUserTotps(optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/current-user/totp`,
            optionsOverrides,
        });
        return result.body;
    }
    async logout(optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/logout/`,
            optionsOverrides,
        });
        return result.body;
    }
    async getCheckSuperAuthentication(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/check-super-authentication`,
            optionsOverrides,
        });
        return result.body;
    }
    async getAuthRequest(role, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/auth/request/${role}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listUsers(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/user/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getUser(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/user/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async createUser(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/user/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteUser(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/user/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async updateUser(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/user/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getUserSettings(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/user/${id}/settings`,
            optionsOverrides,
        });
        return result.body;
    }
    async setUserSettings(id, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/user/${id}/settings`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async updateGroup(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/group/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async createGroup(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/group/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async listGroups(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/group/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getGroup(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/group/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteGroup(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/group/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async getGroupCoreSecret(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/group/${id}/core-secret`,
            optionsOverrides,
        });
        return result.body;
    }
    async setGroupCoreSecret(id, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/group/${id}/core-secret`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getInputServiceOverview(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/${id}/service-overview`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getServiceGraphConfig(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/service-graph/config`,
            optionsOverrides,
        });
        return result.body;
    }
    async createInput(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getInputStreamGraph(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/${id}/stream-graph`,
            optionsOverrides,
        });
        return result.body;
    }
    async listInputs(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getInput(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/${id}`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async updateInput(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async pcapInput(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/${id}/pcap/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async sendToOutputsInput(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/${id}/sendToOutputs`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async updateRecipientsInput(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/${id}/updateRecipients`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async rerouteInput(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/${id}/reroute`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async enableInputPreview(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/${id}/preview/enable`,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteInput(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/input/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteInputs(regularQueryParams, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/input`,
            regularQueryParams,
            optionsOverrides,
        });
        return result.body;
    }
    async listInputDistributions(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/${id}/distribution/`,
            optionsOverrides,
        });
        return result.body;
    }
    async setInputDistributions(id, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/input/${id}/distribution/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getInputHealth(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/${id}/health/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getInputHlsAccess(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/${id}/hls-access`,
            optionsOverrides,
        });
        return result.body;
    }
    async getChannelCheckThumbReadAccess(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/channel/${id}/check-thumb-read-access`,
            optionsOverrides,
        });
        return result.body;
    }
    async setInputAdminStatuses(body, optionsOverrides = {}) {
        const result = await this._patch({
            resource: `/api/input/admin-status`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async updateOutput(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/output/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async setOutputInput(id, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/output/${id}/input`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async createOutput(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/output/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async listOutputs(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/output/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getOutput(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/output/${id}`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getOutputHealth(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/output/${id}/health/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteOutput(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/output/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteOutputs(regularQueryParams, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/output`,
            regularQueryParams,
            optionsOverrides,
        });
        return result.body;
    }
    async setOutputAdminStatuses(body, optionsOverrides = {}) {
        const result = await this._patch({
            resource: `/api/output/admin-status`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getDashboardBitrates(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/dashboard/bitrates/`,
            optionsOverrides,
        });
        return result.body;
    }
    async getThumbRoutes(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/internal/thumb-routes`,
            optionsOverrides,
        });
        return result.body;
    }
    async region(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/internal/region/${id}/rpc`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async listRawThumbRoutes(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/raw-thumb-routes`,
            optionsOverrides,
        });
        return result.body;
    }
    async getBuildInfo(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/build-info`,
            optionsOverrides,
        });
        return result.body;
    }
    async listRpcSessions(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/rpc-session/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteRpcSession(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/rpc-session/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listAlarmLogs(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/alarm-log/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async cloudApplianceAuditLogs(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/audit-log/cloud-appliance/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async beginAuditLogSystemUpgrades(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/audit-log/system/upgrade/begin`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async completeAuditLogSystemUpgrades(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/audit-log/system/upgrade/complete`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async listAuditLogs(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/audit-log/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listAdAuditLogs(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ad-audit-log/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getOutputRecipientList(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/outputRecipientList/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listOutputRecipientListOutputs(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/outputRecipientList/${id}/outputs`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listOutputRecipientListOutputsNotInLists(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/outputRecipientList/${id}/outputsNotInList`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listOutputRecipientLists(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/outputRecipientList/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async createOutputRecipientList(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/outputRecipientList/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async updateOutputRecipientList(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/outputRecipientList/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteOutputRecipientList(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/outputRecipientList/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listOutputAndRecipientLists(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/outputAndRecipientList/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listGroupRecipientLists(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/groupRecipientList/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getGroupRecipientList(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/groupRecipientList/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listGroupRecipientListGroups(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/groupRecipientList/${id}/groups`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listGroupRecipientListGroupsNotInLists(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/groupRecipientList/${id}/groupsNotInList`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async createGroupRecipientList(body, query, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/groupRecipientList/`,
            query,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async updateGroupRecipientList(id, body, query, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/groupRecipientList/${id}`,
            query,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteGroupRecipientList(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/groupRecipientList/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listGroupAndRecipientLists(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/groupAndRecipientList/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getCoreSecret(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/internal/core-secret`,
            optionsOverrides,
        });
        return result.body;
    }
    async getBillingReport(regularQueryParams, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/billing-report`,
            regularQueryParams,
            optionsOverrides,
        });
        return result.body;
    }
    async getUsageReport(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/usage-report`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listNetworks(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/network`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getNetwork(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/network/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async createNetwork(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/network`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async updateNetwork(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/network/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteNetwork(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/network/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listTags(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/tag/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listServices(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/service/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getService(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/service/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async updateService(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/service/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getGrafanaDashboardsHome(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/grafana/api/dashboards/home`,
            optionsOverrides,
        });
        return result.body;
    }
    async listGrafanaDashboards(regularQueryParams, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/grafana/api/search`,
            regularQueryParams,
            optionsOverrides,
        });
        return result.body;
    }
    async setGrafanaUserHelpflags(flag, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/grafana/api/user/helpflags/${flag}`,
            optionsOverrides,
        });
        return result.body;
    }
    async createGrafanaApiUserStarsDashboard(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/grafana/api/user/stars/dashboard/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async getHealthBackendAppliance(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/health-backend-appliance`,
            optionsOverrides,
        });
        return result.body;
    }
    async registerAppliance(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/register`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getApplianceConfig(id, secret, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/config`,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async sendApplianceVersionMessage(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/message/version`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async sendApplianceSrtStatsMessage(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/message/srt-stats`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async sendApplianceRtmpStatsMessage(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/message/rtmp-stats`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async sendApplianceZixiBroadcasterStatsMessage(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/message/zixi-broadcaster-stats`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async sendApplianceAdStageStatsMessage(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/message/ad-stage-stats`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async sendApplianceProgressMessage(id, cmdId, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/message/command/${cmdId}/progress`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async messageAppliance(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/message`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async logAppliance(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/log`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async getCoreSecretAppliance(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/internal/core-secret-appliance`,
            optionsOverrides,
        });
        return result.body;
    }
    async getThumbWriteAccess(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/internal/auth/thumb-write-access`,
            optionsOverrides,
        });
        return result.body;
    }
    async getHealthStreamMonitor(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/health-stream-monitor`,
            optionsOverrides,
        });
        return result.body;
    }
    async getApplianceSoftware(optionsOverrides = { json: false }) {
        const result = await this._get({
            resource: `/api/appliance/software`,
            optionsOverrides,
        });
        return result.body;
    }
    async applianceSoftware(body, optionsOverrides = { json: false }) {
        const result = await this._post({
            resource: `/api/appliance/software`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getHealthAdService(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/health-ad-service`,
            optionsOverrides,
        });
        return result.body;
    }
    get baseUrl() {
        if (Date.now() - this._baseUrlLastSet > 60000) {
            this.baseUrl = this.baseUrls.reset();
        }
        return this._baseUrl;
    }
    set baseUrl(url) {
        this._baseUrlLastSet = Date.now();
        this._baseUrl = url;
    }
    async _get(params) {
        return this._call('GET', params);
    }
    async _post(params) {
        return this._call('POST', params);
    }
    async _put(params) {
        return this._call('PUT', params);
    }
    async _delete(params) {
        return this._call('DELETE', params);
    }
    async _patch(params) {
        return this._call('PATCH', params);
    }
    _call(method, params) {
        const queryParams = Object.assign({}, params.regularQueryParams);
        if (params.query) {
            const queryObject = (0, query_1.toQueryParams)(params.query);
            Object.assign(queryParams, queryObject);
        }
        const queryString = Object.entries(queryParams)
            .reduce((acc, [key, value]) => {
            return [
                ...acc,
                value === undefined || value === null
                    ? `${this.encode(key)}=`
                    : `${this.encode(key)}=${this.encode(value)}`,
            ];
        }, [])
            .join('&');
        const url = `${this.baseUrl}${params.resource}?${queryString}`;
        return this.request({
            method,
            url,
            body: params.body,
            optionsOverrides: params.optionsOverrides,
        });
    }
    async request(params, attempt = 1) {
        try {
            return await this._request(params);
        }
        catch (err) {
            if (this.baseUrls.length > attempt) {
                this.baseUrl = this.baseUrls.next().value;
                return this.request(params, attempt + 1);
            }
            throw err;
        }
    }
    /// https://github.com/axios/axios/blob/master/lib/helpers/buildURL.js
    encode(val) {
        return encodeURIComponent(val)
            .replace(/%3A/gi, ':')
            .replace(/%24/g, '$')
            .replace(/%2C/gi, ',')
            .replace(/%20/g, '+')
            .replace(/%5B/gi, '[')
            .replace(/%5D/gi, ']');
    }
}
exports.EdgeClient = EdgeClient;
//# sourceMappingURL=data:application/json;base64,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